import React, { useState } from 'react'
import { Button, FormControl, InputLabel, Menu, MenuItem, Select, styled, TextField } from '@mui/material'
import { __snackBarSeverity } from '../constants';

export default function EditMenu({ menuRef, open, id, title, onSave, onCancel, isTextField, isDateField, isNumberField, isActiveDropdown, currentValue }) {
    const [state, setState] = useState({ status: "", value: '' })

    return (
        <Menu
            anchorEl={menuRef}
            open={open}
            onClose={onCancel}
        >
            <Container>
                <p>{title}</p>
                {isActiveDropdown &&
                    <FormControl fullWidth style={{ margin: '20px 0 10px 0' }}>
                        <InputLabel id='status'>Status</InputLabel>
                        <Select
                            defaultValue={currentValue}
                            multiline
                            onChange={(e) => { setState({ ...state, status: e.target.value }) }}
                            id='status'
                            label="Select status">
                            <MenuItem value={"Active"} >Active</MenuItem>
                            <MenuItem value={"Inactive"} >Inactive</MenuItem>
                        </Select>
                    </FormControl>
                }

                {(isTextField || isDateField || isNumberField )&&
                    <TextField
                        autoFocus
                        margin="dense"
                        id="value"
                        label={isDateField ? "Date" : isNumberField ? "Enter value" : "text"}
                        type={isDateField ? "date" : isNumberField ? "number" : "text"}
                        // type={'date'}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => { setState({ ...state, value: e.target.value }) }}
                    />
                }

                <Actions>
                    <Button variant="contained" size='small' style={{ textTransform: "unset" }} onClick={() => onSave(state, id)}>Save</Button>
                    <Button variant="outlined" size='small' style={{ textTransform: "unset" }} onClick={() => onCancel()}>Cancel</Button>
                </Actions>
            </Container>
        </Menu>
    )
}

const Container = styled("div")`
    padding: 1rem;
    width  :300px;
    .my-2{
        margin-top: 1rem;
    }
`;
const Actions = styled("div")`
    margin-top: 1rem;
    display: flex;
    column-gap: 1rem;
`;